<template>
  <div class="columns account-info-wrapper">
    <div class="column">
      <account-info class="content-block"></account-info>
      <company-info class="content-block"></company-info>

    </div>
    <div class="column is-one-third"></div>

  </div>
</template>

<script>
import AccountInfo from '../AccountInfo'
import CompanyInfo from '../CompanyInfo'

export default {
  name: 'BasicAccountInfo-Shipper',

  components: {
    AccountInfo,
    CompanyInfo
  }
}
</script>

<style scoped lang="scss">
.content-block {
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid lightgray;
}
</style>
